import * as React from 'react';
import { useGetMembersGroupQuery } from "../../../apis/MembersGroup.api";
import { PrimaryMembersGroup, MembersGroup } from "../../../types/models/MembersGroup";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: MembersGroup;
};

export const MembersGroupNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.hierarchyName }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const MembersGroupName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetMembersGroupQuery(PrimaryMembersGroup.fromId(id))
    return (<MembersGroupNameDisplay data={data}/>)
}

export default MembersGroupName;
